import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-contact-list-image-cell-renderer',
    templateUrl: './contact-list-image-cell-renderer.component.html',
    styleUrls: ['./contact-list-image-cell-renderer.component.scss']
})
export class ContactListImageCellRendererComponent implements AgRendererComponent {

    params: ICellRendererParams;
    imageUrl = '';
    state = '';

    constructor() { }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        this.state = params.value;
        this.imageUrl = this.getImgUrl(this.state);

        return true;
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.state = params.value;
        this.imageUrl = this.getImgUrl(this.state);
    }

    private getImgUrl(state) {
        let url;
        switch (state) {
            case 'PHONE CALL':
                return url = "../App_Themes/CXone/icons/widget-call.svg#widget-call";
            case 'Inbound':
                return url = "../App_Themes/CXone/icons/inbound.svg#inbound";
            case 'Outbound':
                return url = "../App_Themes/CXone/icons/outbound.svg#outbound";
            case 'CHAT':
                return url = "../App_Themes/CXone/icons/widget-chat.svg#widget-chat";
            case 'VOICE MAIL' :
                return url = "../App_Themes/CXone/icons/voicemail.svg#voicemail"; // change when we have
            case 'SMS':
                return url = "../App_Themes/CXone/icons/widget-sms.svg#widget-sms";
            case 'E-MAIL':
                return url = "../App_Themes/CXone/icons/widget-email.svg#widget-email";
            case 'WORK ITEM':
                return url = "../App_Themes/CXone/icons/widget-work-item.svg#widget-work-item";
            case 'DIGITAL':
                return url = "../App_Themes/CXone/icons/social/digital-engagement.svg#digital-engagement";
            case 'SLACK':
                return url = "../App_Themes/CXone/icons/social/slack.svg#slack";
            case 'TELEGRAM':
                return url = "../App_Themes/CXone/icons/social/telegram.svg#telegram";
            case 'CHANNEL': // from here below not 100 percent sure they will actually be used in this widget
                return url = "../App_Themes/CXone/icons/social/channel.svg#channel";
            case 'APPLE':
                return url = "../App_Themes/CXone/icons/social/apple.svg#apple";
            case 'GOOGLE BUSINESS MESSENGER':
                return url = "../App_Themes/CXone/icons/social/google-business-messenger.svg#google-business-messenger";
            case 'LINE':
                return url = "../App_Themes/CXone/icons/social/line.svg#line";
            case 'TEAMS MSG':
                return url = "../App_Themes/CXone/icons/social/teams-msg.svg#teams-msg";
            case "TWITTER":
                return url = "../App_Themes/CXone/icons/social/twitter.svg#twitter";
            case 'VIBER':
                return url = "../App_Themes/CXone/icons/social/viber.svg#viber";
            case 'WHATS APP':
                return url = "../App_Themes/CXone/icons/social/whats-app.svg#whats-app";
        }
    }

}
